import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-integration-bp-ui-form',
  templateUrl: './integration-bp-ui-form.component.html',
  styleUrls: ['./integration-bp-ui-form.component.scss']
})
export class IntegrationBpUiFormComponent {
  @Input() formGroup!: FormGroup;
}
